/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.26",
    versionName: "0.2.0-nightly.2025.7.26",
    versionChannel: "nightly",
    buildDate: "2025-07-26T00:07:53.515Z",
    commitHash: "102b5e7d9401925cd16dac3653c018dc283ae84e",
};
